import request from "@/utils/request";

// 查看会议
export function search_meeting(data) {
    return request({
        url: "/search_meeting",
        method: "post",
        data: data,
    });
}
// 会议详情
export function meeting_particulars(data) {
    return request({
        url: "/meeting_particulars",
        method: "post",
        data: data,
    });
}
// 添加会议
export function add_meeting(data) {
    return request({
        url: "/add_meeting",
        method: "post",
        data: data,
    });
}
// 修改会议
export function update_meeting(data) {
    return request({
        url: "/update_meeting",
        method: "post",
        data: data,
    });
}
// 删除会议
export function delete_meeting(data) {
    return request({
        url: "/delete_meeting",
        method: "post",
        data: data,
    });
}
// 删除会议
export function refresh_meeting(data) {
    return request({
        url: "/refresh_meeting",
        method: "post",
        data: data,
    });
}
// 期刊名称搜索
export function search_journal_name(data) {
    return request({
        url: "/search_journal_name",
        method: "post",
        data: data,
    });
}
// 查询会议
export function advertising_list(data) {
    return request({
        url: "/advertising/list",
        method: "post",
        data: data,
    });
}
// 查询会议轮播
export function advertising_listForHomePage(data) {
    return request({
        url: "/advertising/listForHomePage",
        method: "post",
        data: data,
    });
}
// 修改会议轮播
export function advertising_update_slide(data) {
    return request({
        url: "/advertising/update_slide",
        method: "post",
        data: data,
    });
}



